import debounce from "./debounce"

export class LogFormDrafts {
  static selector = "textarea[data-autosave-log-draft='true']"
  static storagePrefix = "log_draft:v1"

  static initAll() {
    $(document).find(LogFormDrafts.selector).each(function(_, textarea){
      new LogFormDrafts(textarea)
    })
  }

  constructor(textarea) {
    this.textarea = $(textarea)
    this.form = this.textarea.closest("form")
    this.storageKey = this.buildStorageKey()

    if (this.storageKey == null)
      return

    this.restoreDraft()
    this.addTriggers()
  }

  buildStorageKey() {
    let scope = this.textarea.data("autosave-log-draft-scope")

    if (scope == undefined || scope.toString().trim() == "")
      return null

    return `${LogFormDrafts.storagePrefix}:${scope}`
  }

  addTriggers() {
    let klass = this

    this.textarea.on("input", debounce(function(){
      klass.saveDraft()
    }, 250))

    this.form.on("ajax:success", function(){
      klass.clearDraft()
    })
  }

  saveDraft() {
    if (!this.supportsStorage())
      return

    let value = this.textarea.val()

    if (value == undefined || value.trim() == "") {
      this.clearDraft()
      return
    }

    localStorage.setItem(this.storageKey, value)
  }

  restoreDraft() {
    if (!this.supportsStorage())
      return

    let currentValue = this.textarea.val()
    let draft = localStorage.getItem(this.storageKey)

    if ((currentValue == undefined || currentValue.trim() == "") && draft != null)
      this.textarea.val(draft)
  }

  clearDraft() {
    if (!this.supportsStorage())
      return

    localStorage.removeItem(this.storageKey)
  }

  supportsStorage() {
    try {
      return typeof localStorage != "undefined"
    } catch (_e) {
      return false
    }
  }
}